import script from "./recordDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./recordDetails.vue?vue&type=script&lang=ts&setup=true"

import "./recordDetails.vue?vue&type=style&index=0&id=27495d48&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27495d48"]])

export default __exports__